module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-sm"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [(!_vm.subscription.isSubcriptionActive) ? [_vm._v("Activate Dynamic Pricing Add-on")] : [_vm._v("Dynamic Pricing Add-on Activated")]], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex flex-column p-4 fs-large"
  }, [_c('span', {
    staticClass: "mt-4"
  }, [_vm._v("This add-on will apply a "), _c('strong', [_vm._v("0.3% fee")]), _vm._v(" on the total value of\n                    reservations.")]), _vm._v(" "), (!_vm.subscription.isSubcriptionActive) ? [_c('span', {
    staticClass: "mt-4"
  }, [_vm._v("\n                        Please refer to the Payment Terms and Conditions for more information.\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "my-4"
  }, [_vm._v("\n                        Do you want to activate this add-on?\n                    ")])] : [_c('span', {
    staticClass: "mt-4"
  }, [_vm._v("\n                        By deactivating this feature, all existing rules groups and rules will be permanently\n                        deleted.\n                        You will also lose the ability to create new ones.\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mt-4"
  }, [_vm._v("If you deactivate this add-on, you will still be billed in the next invoice\n                        cycle for the period in which it was active — from the last billing date until the day of\n                        cancellation.")]), _vm._v(" "), _c('span', {
    staticClass: "my-4"
  }, [_vm._v("\n                        Please refer to the Payment Terms and Conditions for more information.\n                    ")])]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "d-flex justify-content-start pr1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.subscription.isSubcriptionActive),
      expression: "this.subscription.isSubcriptionActive"
    }],
    staticClass: "btn action ml-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.execute()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-trash-alt fs-small mr-1"
  }), _vm._v(" "), _c('span', [_vm._v("Deactivate")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end pr1"
  }, [_c('button', {
    staticClass: "btn cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.subscription.isSubcriptionActive),
      expression: "!this.subscription.isSubcriptionActive"
    }],
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.execute()
      }
    }
  }, [_c('span', [_vm._v("Activate")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-83cf0886", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83cf0886"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/Subscriptions.vue
// module id = 2136
// module chunks = 0